import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { Container, Row, Col, Box } from "@ui/wrapper"
import Heading from "@ui/heading"
import Text from "@ui/text"
import { TeamListWrapper } from "./team-list-area.style"
import SectionTitle from "@ui/section-title"

const TeamListArea = ({
  sectionTitleStyle,
  sectionStyle,
  headingStyle,
  boxStyles,
}) => {
  const teamData = useStaticQuery(graphql`
    query {
      TeamDevs: allTeamsJson(
        filter: { position: { eq: "Academic Visitors" } }
      ) {
        edges {
          node {
            id
            name
            link
          }
        }
      }
      TeamStaffs: allTeamsJson(
        filter: { position: { eq: "Research Interns" } }
      ) {
        edges {
          node {
            id
            name
            link
          }
        }
      }
      TeamDesigner: allTeamsJson(filter: { position: { eq: "Alumni" } }) {
        edges {
          node {
            id
            name
            link
          }
        }
      }
    }
  `)
  const hdrstudents = teamData.TeamDevs.edges
  const researchinterns = teamData.TeamStaffs.edges
  const alumni = teamData.TeamDesigner.edges

  return (
    <TeamListWrapper>
      <Container justify="center" align="middle">
        <SectionTitle
          {...sectionTitleStyle}
          // title="All Categories of Our Publications"
          subtitle="Research Interns"
        />
        <Row justify="center">
          {researchinterns &&
            researchinterns.map(engineer => (
              <Text style={{ marginRight: "15px" }} key={engineer.node.id}>
                {" "}
                <a href={engineer.node.link} target="_blank" rel="noopener noreferrer">{engineer.node.name}</a>{" "}
              </Text>
            ))}
        </Row>
        <SectionTitle
          {...sectionTitleStyle}
          style={{ marginTop: "40px" }}
          // title="All Categories of Our Publications"
          subtitle="Academic Visitors"
        />
        <Row justify="center">
          {hdrstudents &&
            hdrstudents.map(staff => (
              <Text style={{ marginRight: "15px" }} key={staff.node.id}>
                <a href={staff.node.link} target="_blank" rel="noopener noreferrer">{staff.node.name}</a>
              </Text>
            ))}
        </Row>
        <SectionTitle
          {...sectionTitleStyle}
          style={{ marginTop: "25px" }}
          // title="All Categories of Our Publications"
          subtitle="Alumni"
        />
        <Row justify="center">
          {alumni &&
            alumni.map(designer => (
              <Text key={designer.node.id} style={{ marginRight: "15px" }}>
                <a href={designer.node.link} target="_blank" rel="noopener noreferrer">{designer.node.name}</a>
              </Text>
            ))}
        </Row>
      </Container>
    </TeamListWrapper>
  )
}

TeamListArea.propTypes = {
  headingStyle: PropTypes.object,
  boxStyles: PropTypes.object,
}

TeamListArea.defaultProps = {
  sectionTitleStyle: {
    mb: "30px",
    responsive: {
      small: {
        mb: "20px",
      },
    },
  },
  headingStyle: {
    as: "h3",
    fontSize: "15px",
    texttransform: "uppercase",
    letterspacing: "1px",
    mb: "22px",
  },
  boxStyles: {
    responsive: {
      small: {
        mb: "41px",
      },
    },
  },
}

export default TeamListArea
